/**
 * One identity per easement row: documentId + datoloebenr.
 * Session row.id stays stable (today's matrix key) and is not a second identity.
 */
import { normalizeServitutIdentity, type NormalizedServitutIdentity } from "src/modules/ANNModule/ANNServitutIdentity";

export function rowIdentity(servitut: unknown): NormalizedServitutIdentity {
   return normalizeServitutIdentity(servitut as never);
}

export function annotationDocumentId(servitut: { dokumentId?: string; aktAliasId?: string } | unknown): string {
   const source = (servitut || {}) as { dokumentId?: string; aktAliasId?: string };
   return (source.dokumentId || source.aktAliasId || "").trim();
}

export function canonicalDocumentId(servitut: unknown, fallback = ""): string {
   const identity = rowIdentity(servitut);
   return annotationDocumentId(servitut) || identity.documentId || fallback;
}

export function rowDocumentId(row: {
   id?: string;
   identity?: { documentId?: string };
   landRegistry?: { servitut?: unknown };
}): string {
   return String(
      row.identity?.documentId
      || canonicalDocumentId(row.landRegistry?.servitut, row.id || ""),
   ).trim();
}

/** Every id this row may have been saved under. Notes and Document must all match one of these. */
export function rowDocumentIds(row: {
   id?: string;
   identity?: { documentId?: string };
   landRegistry?: { servitut?: unknown };
}): string[] {
   const ids = [
      row.identity?.documentId,
      canonicalDocumentId(row.landRegistry?.servitut, row.id || ""),
      annotationDocumentId(row.landRegistry?.servitut),
      row.id,
   ]
      .map((value) => String(value || "").trim())
      .filter(Boolean);
   return [...new Set(ids)];
}

export function normalizeDatoLoebenrDigits(value?: string): string {
   return (value || "").replace(/[^0-9]/g, "");
}
